var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createRequest } from "@hg/one-account";
var request;
var queue = [];
export var getRequestClient = function (_a) {
    var baseURL = _a.baseURL, sdkReady = _a.sdkReady, errCode2Msg = _a.errCode2Msg;
    if (!request) {
        request = createGlobalRequest({ baseURL: baseURL, sdkReady: sdkReady, errCode2Msg: errCode2Msg });
        var todo = queue.shift();
        while (todo) {
            todo(request);
            todo = queue.shift();
        }
    }
    else {
        request.defaults.baseURL = baseURL;
    }
    return request;
};
export var requestReady = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (request)
            return [2 /*return*/, request];
        return [2 /*return*/, new Promise(function (resolve) {
                queue.push(resolve);
            })];
    });
}); };
var createGlobalRequest = function (_a) {
    var sdkReady = _a.sdkReady, baseURL = _a.baseURL, timeout = _a.timeout, errCode2Msg = _a.errCode2Msg;
    var request = createRequest({
        sdkReady: sdkReady,
        requestOption: {
            baseURL: baseURL,
            responseType: "json",
            timeout: timeout || 5000,
            withCredentials: true,
        },
    });
    request.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            document.body.classList.add("wait");
            return [2 /*return*/, config];
        });
    }); }, function (error) {
        var _a;
        document.body.classList.remove("wait");
        return Promise.resolve({
            code: -1,
            msg: (_a = error.message) !== null && _a !== void 0 ? _a : "Request Error",
        });
    });
    request.interceptors.response.use(function (response) {
        var _a;
        document.body.classList.remove("wait");
        if (response.data) {
            response.data.msg =
                (_a = errCode2Msg === null || errCode2Msg === void 0 ? void 0 : errCode2Msg[response.data.code]) !== null && _a !== void 0 ? _a : response.data.msg;
        }
        return response.data;
    }, function (error) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        document.body.classList.remove("wait");
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) >= 500) {
            return Promise.resolve({
                code: -1,
                msg: "Network Error",
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var resData = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data;
        if (resData) {
            return Promise.resolve({
                code: (_d = resData.code) !== null && _d !== void 0 ? _d : resData.statusCode,
                msg: (_f = (_e = errCode2Msg === null || errCode2Msg === void 0 ? void 0 : errCode2Msg[resData.code]) !== null && _e !== void 0 ? _e : resData.msg) !== null && _f !== void 0 ? _f : resData.message,
            });
        }
        return Promise.resolve({
            code: -1,
            msg: (_j = (_h = (_g = error.response) === null || _g === void 0 ? void 0 : _g.statusText) !== null && _h !== void 0 ? _h : error.message) !== null && _j !== void 0 ? _j : "Request Error",
        });
    });
    return request;
};
export { request };
